export default __webpack_public_path__ + "static/media/atom-i-action.acda6c3c.svg";